"use strict";

/**
 * @namespace
 */
gc.gis.feature = gc.gis.feature || {};

/**
 * @classdesc
 * Abstrakte Wrapperklasse für Featureobjekte.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.feature
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} feature gewrappte Feature-Instanz
 */
gc.gis.feature.GCFeature = function(feature)
{
    gc.gis.GCWrappable.call(this);

    this._feature = feature;
};
gc.gis.feature.GCFeature.prototype = Object.create(gc.gis.GCWrappable.prototype);


/**
 * @inheritdoc
 */
gc.gis.feature.GCFeature.prototype.getImpl = function()
{
    return this._feature;
};

/**
 * Setzt die ID des Features.
 *
 * @abstract
 * @method
 * @public
 * @param {number|string|undefined} id
 * @return {gc.gis.feature.GCFeature}
 */
gc.gis.feature.GCFeature.prototype.setID = gc.gis.abstractMethod;

/**
 * Gibt die ID des Features zurück.
 *
 * @abstract
 * @method
 * @return {number|string|undefined} ID
 * @public
 */
gc.gis.feature.GCFeature.prototype.getID = gc.gis.abstractMethod;

/**
 * Setzt die Geometrie des Features.
 *
 * @abstract
 * @method
 * @param {gc.gis.geom.GCGeometry|undefined} geometry
 * @return {gc.gis.feature.GCFeature}
 * @public
 */
gc.gis.feature.GCFeature.prototype.setGeometry = gc.gis.abstractMethod;

/**
 * Gibt die Geometrie des Features zurück.
 *
 * @abstract
 * @method
 * @return {gc.gis.geom.GCGeometry|undefined} Geometrie
 * @public
 */
gc.gis.feature.GCFeature.prototype.getGeometry = gc.gis.abstractMethod;

/**
 * Setzt ein Attribut des Features.
 *
 * @abstract
 * @method
 * @param {string} name
 * @param {*} value
 * @return {gc.gis.feature.GCFeature}
 * @public
 */
gc.gis.feature.GCFeature.prototype.setAttribute = gc.gis.abstractMethod;

/**
 * Setzt ein Attributwert des Features zurück.
 *
 * @abstract
 * @method
 * @param {string} name
 * @return {gc.gis.feature.GCFeature}
 * @public
 */
gc.gis.feature.GCFeature.prototype.unsetAttribute = gc.gis.abstractMethod;

/**
 * Gibt ein Attribut des Features zurück.
 *
 * @abstract
 * @method
 * @param {string} name
 * @return {*} Attribut-Wert
 * @public
 */
gc.gis.feature.GCFeature.prototype.getAttribute = gc.gis.abstractMethod;

/**
 * Klont das Feature und wenn vorhanden die Geometrie. Die Feature-ID wird nicht in den Klon übertragen.
 *
 * @abstract
 * @method
 * @return {gc.gis.feature.GCFeature}
 * @public
 */
gc.gis.feature.GCFeature.prototype.clone = gc.gis.abstractMethod;